import { render, staticRenderFns } from "./root.vue?vue&type=template&id=3e0f26b8&lang=pug&"
import script from "./root.vue?vue&type=script&lang=js&"
export * from "./root.vue?vue&type=script&lang=js&"
import style0 from "./root.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e0f26b8')) {
      api.createRecord('3e0f26b8', component.options)
    } else {
      api.reload('3e0f26b8', component.options)
    }
    module.hot.accept("./root.vue?vue&type=template&id=3e0f26b8&lang=pug&", function () {
      api.rerender('3e0f26b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fv_atril_video/root.vue"
export default component.exports